import { render, staticRenderFns } from "./MembersTab.vue?vue&type=template&id=bc5825c8"
import script from "./MembersTab.vue?vue&type=script&lang=js"
export * from "./MembersTab.vue?vue&type=script&lang=js"
import style0 from "./MembersTab.vue?vue&type=style&index=0&id=bc5825c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports